define('home/views/ChannelModeratorUserView',[
    'backbone-marionette',

    'home/templates/channelModeratorUser',
], function (
    Marionette,

    channelModeratorUserTemplate
) {
    'use strict';

    /**
     * Shows a single channel moderator card. Shows a creator badge if user
     * is the channel creator, but not a mod badge since the item is assumed
     * to appear in a list where every user is a moderator.
     *
     * Expects a User model and a Channel given as an option.
     */
    var ChannelModeratorUserView = Marionette.ItemView.extend({
        className: 'card',

        template: channelModeratorUserTemplate,
        templateHelpers: function () {
            return {
                isChannelOwner: this.isChannelOwner,
            };
        },

        initialize: function (options) {
            this.channel = options.channel;
            var ownerId = this.channel.get('owner_id');
            this.isChannelOwner = ownerId === this.model.get('id');
        },

        events: {
            'click [data-action=remove-moderator]': 'removeModerator',
        },

        /**
         * Removes the backing User as a moderator on the given Channel.
         * Does not handle backend errors, since user should not be able to
         * kick off this api call unless requirements are already satisfied
         */
        removeModerator: function () {
            this.model.moderateChannel(this.channel, false);
        },
    });

    return ChannelModeratorUserView;
});

